import {Component, OnDestroy, OnInit} from '@angular/core';
import {CsvExportParams, GridApi, GridOptions, IDatasource, IGetRowsParams} from 'ag-grid-community';
import {User} from '../../services/user/user';
import {ISubscription} from 'rxjs-compat/Subscription';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {HhgCarrierRateFilingService} from '../hhg-carrier-rate-filing/hhg-carrier-rate-filing.service';
import {AlertService} from '../../services/alert/alert.service';
import {LoadingService} from '../../services/loading/loading.service';
import {UserService} from '../../services/user/user.service';
import {DownloadFileResponse} from '../../shared/common-components/file-storage/downloadFileResponse';
import {ConfirmationModalComponent} from '../../shared/common-components/confirmation-modal/confirmation-modal.component';
import * as FileSaver from 'file-saver';
import {api_error, frt_download_success} from '../../shared/common-components/AppConstants';
import {FrtRateDownloadService} from './frt-rate-download.service';
import {ButtonRendererComponent} from './ButtonRendererComponent';
import {FrtAccesorialsTableComponent} from '../frt-accesorials-table/frt-accesorials-table.component';
import {CarrierService} from '../../services/carrier/carrier.service';
import {Ratesprocuredownload} from './ratesprocuredownload';
import {takeWhile} from 'rxjs';
import {BehaviorSubject} from 'rxjs';
import {AgGridAngular} from "ag-grid-angular";
import {RouterLink} from "@angular/router";


@Component({
    selector: 'app-frt-rates-download',
    templateUrl: './frt-rates-download.component.html',
    styleUrls: ['./frt-rates-download.component.css'],
    imports: [AgGridAngular, RouterLink]
})
export class FrtRatesDownloadComponent implements OnInit, OnDestroy {
  private observer$ = new BehaviorSubject(true);
  rateBidCyclesId: number;

  constructor(private hhgService: HhgCarrierRateFilingService, private frtrateDownload: FrtRateDownloadService, private alertService: AlertService,
              private loader: LoadingService, private userService: UserService, private modalService: BsModalService,
              private carrierService: CarrierService) {

    this.tmssloader = this.loader;
    this.overlayLoadingTemplate = '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>';
    this.overlayNoRowsTemplate = '<span style="margin: 27px 53px 0 0;">No results found. Please adjust your filters.</span>';
    this.rateId = 18;
    this.frameworkComponents = {
      buttonRenderer: ButtonRendererComponent,
    };
    this.carrierService.getRateBidCycleId()
      .pipe(takeWhile(() => this.observer$.value)).subscribe((res: any) => {
      this.rateBidCyclesId = res.ratesBidcyclesId;
    });
    /**
     * @description getting current user from the behavioural subject
     */
    this.carrierService.getCarrierObservable()
      .pipe(takeWhile(() => this.observer$.value))
      .subscribe((carrier: any) => {
      if (carrier !== undefined && carrier !== null) {
        this.carrierId = carrier.carrierId;
      } else {
        this.alertService.info('carrierId is null, please click FRT Rate Filing from menu');
      }
    });
    this.columnDefs = [
      {
        headerName: 'UPDATE FLAG',
        field: 'updateFlag',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'BIDCYCLE NAME',
        field: 'bidCycleName'
      },
      {
        headerName: 'SRO',
        field: 'sro',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'TSP',
        field: 'tsp'
      },
      {
        headerName: 'RATE TYPE',
        field: 'tariffServiceCode'
      },

      {
        headerName: 'ORIGINSTATE ZONE',
        field: 'originStateZone',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'ORIGINZONE DESCRIPTION',
        field: 'originZoneDescription',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'DESTINATION STATEZONE',
        field: 'destinationStateZone',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'DESTINATIONZONE DESCRIPTION',
        field: 'destinationZoneDescription',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'TENDERID',
        field: 'tenderId',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'RATE AMOUNT',
        field: 'rateAmount'
      },
      {
        headerName: 'MINIMUM CHARGE',
        field: 'minimumCharge'
      },
      {
        headerName: 'ACCESSORIALS',
        cellRenderer: 'buttonRenderer',
        cellRendererParams: {
          onClick: this.onBtnClick.bind(this),
          label: 'View'
        }
      }
    ];
    this.columnDefsLtl = [
      {
        headerName: 'UPDATE FLAG',
        field: 'updateFlag',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'BIDCYCLE NAME',
        field: 'bidCycleName'
      },
      {
        headerName: 'SRO',
        field: 'sro',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'TSP',
        field: 'tsp'
      },
      {
        headerName: 'TARIFF SERVICECODE',
        field: 'tariffServiceCode'
      },

      {
        headerName: 'ORIGIN STATEZONE',
        field: 'originStateZone',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'ORIGINZONE DESCRIPTION',
        field: 'originZoneDescription',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'DESTINATION STATEZONE',
        field: 'destinationStateZone',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'DESTINATIONZONE DESCRIPTION',
        field: 'destinationZoneDescription',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'TENDERID',
        field: 'tenderId',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'SURCHARGE PERCENTAGE',
        field: 'surchargePercentage'
      },
      {
        headerName: 'MINIMUMCHARGE PERCENTAGE',
        field: 'minimumChargePercentage'
      },
      {
        headerName: 'ACCESSORIALS',
        cellRenderer: 'buttonRenderer',
        cellRendererParams: {
          onClick: this.onBtnClick.bind(this),
          label: 'View'
        }
      }
    ];
    this.columnDefsVehicle = [
      {
        headerName: 'UPDATE FLAG',
        field: 'updateFlag',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'BIDCYCLE NAME',
        field: 'bidCycleName'
      },
      {
        headerName: 'SRO',
        field: 'sro',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'TSP',
        field: 'tsp'
      },
      {
        headerName: 'RATE TYPE',
        field: 'tariffServiceCode'
      },

      {
        headerName: 'ORIGINSTATE ZONE',
        field: 'originStateZone',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'ORIGINZONE DESCRIPTION',
        field: 'originZoneDescription',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'DESTINATION STATEZONE',
        field: 'destinationStateZone',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'DESTINATIONZONE DESCRIPTION',
        field: 'destinationZoneDescription',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'TENDERID',
        field: 'tenderId',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'RATE AMOUNT',
        field: 'rateAmount'
      }
    ];


    this.components = {
      loadingRenderer: function (params) {
        if (params.value !== undefined) {
          return params.value;
        } else {
          return '<img src="../images/loading.gif">';
        }
      }
    };
    this.defaultColDef = {
      sortable: true,
      resizable: true,
      autoHeight: true,
      suppressDragLeaveHidesColumns: true,
      filterParams: {
        suppressAndOrCondition: true
      }
    };
    this.rowSelection = 'multiple';
    this.rowModelType = 'infinite';
    this.cacheOverflowSize = 2;
    this.maxConcurrentDatasourceRequests = 2;
    this.infiniteInitialRowCount = 1;
    this.maxBlocksInCache = 2;
    this.paginationPageSize = 200;
    this.cacheBlockSize = 200;
    this.getRowNodeId = function (item) {
      return item.id;
    };
    this.domLayout = 'autoHeight';

  }
  private tmssloader;
  currentUser: User | any;
  bsModalRef: BsModalRef;
  carrierId: any;
  public modalRef: BsModalRef;
  private gridApi!: GridApi<any>;
  public columnDefs;
  public columnDefsLtl;
  public columnDefsVehicle;
  public components;
  public defaultColDef;
  public rowSelection;
  public rowModelType;
  public paginationPageSize;
  public cacheOverflowSize;
  public maxConcurrentDatasourceRequests;
  public infiniteInitialRowCount;
  public maxBlocksInCache;
  public getRowNodeId;
  public cacheBlockSize;
  paramsObj: any;
  public overlayLoadingTemplate;
  public overlayNoRowsTemplate;
  showExport = false;
  public domLayout;
  // mock data
  rateId: any;
  frameworkComponents: any;

  /**
   * The gridOptions is a 'one stop shop' for the entire interface into the grid. The grid options can be used regardless of the framework you are using, however if you are using a framework,
   * you can additionally achieve what grid options provides with your frameworks bindings. How to configure for the particular framework is explained further down this page.
   * we are using infinite row model which will call server to get data every time page changes
   */
  gridOptions: GridOptions = {
    pagination: true,
    rowModelType: 'infinite',
    paginationPageSize: 500,
    cacheBlockSize: 500,
    headerHeight: 50
  };

  /**
   *  Setting new datasource into the grid. The grid will reset all paging and load the first page. If you want to reset the paging but keep the datasource, call this method with the same datasource.
   */
  dataSource: IDatasource = {
    getRows: (params: IGetRowsParams) => {
      const paramsObj = FrtRatesDownloadComponent.getFilterModal(params.filterModel, params.sortModel);
      this.paramsObj = paramsObj;
      if (this.carrierId !== null && this.carrierId !== undefined && this.rateId !== undefined && this.rateId !== null) {
        this.gridApi.showLoadingOverlay();
        const ratesPoc = this.buildData();
        this.frtrateDownload.getRowDataWithPage(ratesPoc, this.gridApi.paginationGetCurrentPage(), this.gridOptions.paginationPageSize).subscribe((data: any) => {
          const endParam = this.gridOptions.cacheBlockSize;
          setTimeout(() =>  {
            const dataAfterSortingAndFiltering = sortAndFilter(data.content, params.sortModel, params.filterModel);
            const rowsThisPage = dataAfterSortingAndFiltering.slice(0, endParam);
            params.successCallback(
              rowsThisPage,
              data.totalElements
            );
          }, 500);
          this.gridApi.hideOverlay();
          this.showExport = true;
          if (data.content.length === 0) {
            this.gridApi.showNoRowsOverlay();
            this.showExport = false;
          } else {
            this.showExport = true;
            this.gridApi.hideOverlay();
          }
        }, error => {
          this.alertService.info('No results found. Please adjust your filters.');
          this.gridApi.hideOverlay();
          this.showExport = false;
        });
      }
    }
  };

  /**
   * getting the filter and sort params
   * if we switch between cols grid is adding _1 to it and checking those
   * @param: filterParam
   * @param: sortParam
   */
  static getFilterModal(filterParam, sortParam) {
    const paramsObj = [];
    if (filterParam !== null && filterParam !== undefined) {
      if (filterParam.updateFlag) {
        paramsObj.push({name : 'updateFlag' , value: filterParam.updateFlag.filter});
      } else if (filterParam.updateFlag_1) {
        paramsObj.push({name : 'updateFlag' , value: filterParam.updateFlag_1.filter});
      } else {
        paramsObj.push({name : 'updateFlag' , value: ''});
      }
      if (filterParam.sro) {
        paramsObj.push({name : 'sro' , value: filterParam.sro.filter});
      } else if (filterParam.sro_1) {
        paramsObj.push({name : 'sro' , value: filterParam.sro_1.filter});
      } else {
        paramsObj.push({name : 'sro' , value: ''});
      }
      if (filterParam.originStateZone) {
        paramsObj.push({name : 'originStateZone' , value: filterParam.originStateZone.filter});
      } else if (filterParam.originStateZone_1) {
        paramsObj.push({name : 'originStateZone' , value: filterParam.originStateZone_1.filter});
      } else {
        paramsObj.push({name : 'originStateZone' , value: ''});
      }
      if (filterParam.originZoneDescription) {
        paramsObj.push({name : 'originZoneDescription' , value: filterParam.originZoneDescription.filter});
      } else  if (filterParam.originZoneDescription_1) {
        paramsObj.push({name : 'originZoneDescription' , value: filterParam.originZoneDescription_1.filter});
      } else {
        paramsObj.push({name : 'originZoneDescription' , value: ''});
      }
      if (filterParam.destinationStateZone) {
        paramsObj.push({name : 'destinationStateZone' , value: filterParam.destinationStateZone.filter});
      } else if (filterParam.destinationStateZone_1) {
        paramsObj.push({name : 'destinationStateZone' , value: filterParam.destinationStateZone_1.filter});
      } else {
        paramsObj.push({name : 'destinationStateZone' , value: ''});
      }
      if (filterParam.destinationZoneDescription) {
        paramsObj.push({name : 'destinationZoneDescription' , value: filterParam.destinationZoneDescription.filter});
      } else if (filterParam.destinationZoneDescription_1) {
        paramsObj.push({name : 'destinationZoneDescription' , value: filterParam.destinationZoneDescription_1.filter});
      } else {
        paramsObj.push({name : 'destinationZoneDescription' , value: ''});
      }
      if (filterParam.tenderId) {
        paramsObj.push({name : 'tenderId' , value: filterParam.tenderId.filter});
      } else if (filterParam.tenderId_1) {
        paramsObj.push({name : 'tenderId' , value: filterParam.tenderId_1.filter});
      } else {
        paramsObj.push({name : 'tenderId' , value: ''});
      }
    }

    // if we switch between cols grid is adding _1 to it and removing _1
    if (sortParam !== null && sortParam !== undefined && sortParam.length > 0) {
      if (sortParam[0].colId && sortParam[0].sort) {
        sortParam[0].colId = sortParam[0].colId.indexOf('_1') ? sortParam[0].colId.replace(/_1/g, '') : sortParam[0].colId;
        paramsObj.push({name : 'orderByClause' , value: sortParam[0].colId + '_' + sortParam[0].sort});
      } else {
        paramsObj.push({name : 'orderByClause' , value: 'none'});
      }
    } else {
      paramsObj.push({name : 'orderByClause' , value: 'none'});
    }

    if (paramsObj.length === 0) {
      paramsObj.push({name : 'updateFlag' , value: ''});
      paramsObj.push({name : 'sro' , value: ''});
      paramsObj.push({name : 'originStateZone' , value: ''});
      paramsObj.push({name : 'originZoneDescription' , value: ''});
      paramsObj.push({name : 'destinationStateZone' , value: ''});
      paramsObj.push({name : 'destinationZoneDescription' , value: ''});
      paramsObj.push({name : 'tenderId' , value: ''});
      paramsObj.push({name : 'orderByClause' , value: 'none'});
    }
    return paramsObj;
  }

  buildData() {
    const ratesPoc = new Ratesprocuredownload();
    const orderByClause = this.paramsObj.find( x => x.name === 'orderByClause').value;
    const sroId = this.paramsObj.find( x => x.name === 'sro').value ;
    const origzone = this.paramsObj.find( x => x.name === 'originStateZone').value ;
    const origzonedesc = this.paramsObj.find( x => x.name === 'originZoneDescription').value ;
    const destzone = this.paramsObj.find( x => x.name === 'destinationStateZone').value ;
    const destzonedesc = this.paramsObj.find( x => x.name === 'destinationZoneDescription').value ;
    const tenderid = this.paramsObj.find( x => x.name === 'tenderId').value ;
    const updateFlag = this.paramsObj.find( x => x.name === 'updateFlag').value ;
    ratesPoc.carrierId = this.carrierId;
    ratesPoc.rateTypeId = this.rateId;
    ratesPoc.orderByClause = orderByClause;
    ratesPoc.sroId = sroId;
    ratesPoc.origzone = origzone;
    ratesPoc.origzonedesc = origzonedesc;
    ratesPoc.destzone = destzone;
    ratesPoc.updateFlag = updateFlag;
    ratesPoc.destzonedesc = destzonedesc;
    ratesPoc.tenderid = tenderid;
    ratesPoc.ratesBidcyclesId = this.rateBidCyclesId;
    return ratesPoc;
  }

  onBtnClick(e) {
    const initialState = {
      sroMasterId: e.rowData.sroMasterId,
      carrierId: this.carrierId,
      ratesBidcyclesId: this.rateBidCyclesId
    };
    this.bsModalRef = this.modalService.show(FrtAccesorialsTableComponent, {initialState, class: 'modal-lg'});
  }

  /**
   * initializing the ag-grid
   * @param: params
   */
  onGridReady(params: any) {
    params.api.sizeColumnsToFit();
    params.api.resetRowHeights();
    this.gridApi = params.api;
    this.gridApi.setGridOption('columnDefs', this.columnDefs);
    this.gridApi.setGridOption('datasource', this.dataSource);
  }

  ngOnInit() {
  }
  /**
   *
   * @param: $e
   */
  layOutChange(e) {
    this.rateId = e.target.value;
    if (this.rateId === '19') {
      this.gridApi.setGridOption('columnDefs', this.columnDefsLtl);
    } else if (this.rateId > 19) {
      this.gridApi.setGridOption('columnDefs', this.columnDefsVehicle);
    } else {
      this.gridApi.setGridOption('columnDefs', this.columnDefs);
    }
    this.gridApi.refreshHeader();
    this.gridApi.setGridOption('datasource', this.dataSource);
  }

  /**
   * Exporting the data in the csv format
   */
  onBtExport() {
    this.modalRef = this.modalService.show(ConfirmationModalComponent);
    this.modalRef.content.question = 'Select Yes to download ONLY the information that is displayed on this page. Select No to download ALL of the information that is available from the FRT View Rates';
    this.modalRef.content.title = 'FRT View Rates';
    this.modalRef.content.confirmText = 'Yes';
    this.modalRef.content.cancelText = 'No - download all rates with filters';
    this.modalRef.content.emitData.subscribe(result => {
      if (result.obj === true) {
        const date = new Date();
        /** this is to skip accessorials column from the columnsList passed to the csv file **/
        const columnsForExport = [];
        const allColumns = this.gridApi.getAllGridColumns();
        allColumns.forEach((element: any) => {
          if (element.colId !== '0') {
            columnsForExport.push(element.colId);
          }
        });
        const params: CsvExportParams = {
          fileName: 'frt-rates-report-' + date + '.csv',
          columnKeys: columnsForExport,
          columnSeparator: ','
        };
        this.gridApi.exportDataAsCsv(params);
        this.showExport = false;
        setTimeout(() => {
          this.showExport = true;
        }, 5200);
      } else if (result.obj === false) {
        let frtrRatesResult: DownloadFileResponse;
        this.tmssloader.show();
        const ratesPoc = this.buildData();
        this.frtrateDownload.exportDataFromServer(ratesPoc).subscribe((data: any) => {
          frtrRatesResult = data as DownloadFileResponse;
          const byteData: number[] = frtrRatesResult.byteData;
          const fileName: string = frtrRatesResult.fileName;
          const numRows: number = frtrRatesResult.numberOfExcelRows;
          const bytes = new Uint8Array(byteData);
          const blob = new Blob([bytes], {
            type: null
          });
          FileSaver.saveAs(blob, fileName);
          this.alertService.success(frt_download_success);
          this.showExport = false;
          this.tmssloader.hide();

          setTimeout(() => {
            this.showExport = true;
          }, 5200);
        }, error => {
          this.alertService.error(api_error);
          this.tmssloader.hide();
        });
      }
    });

  }

  /**
   * @description unsubcribes to carrie subsription if there is one.
   */
  ngOnDestroy() {
    this.observer$.next(false);
  }
}

/**
 * @param: allOfTheData
 * @param: sortModel
 * @param: filterModel
 */
function sortAndFilter(allOfTheData, sortModel, filterModel) {
  return sortData(sortModel, filterData(filterModel, allOfTheData));
}

/**
 * sorting the data
 * @param: sortModel
 * @param: data
 */
function sortData(sortModel, data) {
  const sortPresent = sortModel && sortModel.length > 0;
  if (!sortPresent) {
    return data;
  }
  const resultOfSort = data.slice();
  resultOfSort.sort(function(a, b) {
    for (let k = 0; k < sortModel.length; k++) {
      const sortColModel = sortModel[k];
      const valueA = a[sortColModel.colId];
      const valueB = b[sortColModel.colId];
      if (valueA === valueB) {
        continue;
      }
      const sortDirection = sortColModel.sort === 'asc' ? 1 : -1;
      if (valueA > valueB) {
        return sortDirection;
      } else {
        return sortDirection * -1;
      }
    }
    return 0;
  });
  return resultOfSort;
}

/**
 * filtering the data
 * @param: filterModel
 * @param: data
 */
function filterData(filterModel, data) {
  const filterPresent = filterModel && Object.keys(filterModel).length > 0;
  if (!filterPresent) {
    return data;
  }
  const resultOfFilter = [];
  for (let i = 0; i < data.length; i++)   {
    const item = data[i];
    if (filterModel.Accessorials) {
      if (filterModel.Accessorials.filter.toUpperCase().indexOf(item.Accessorials.toString().toUpperCase()) < 0) {
        continue;
      }
    }
    resultOfFilter.push(item);
  }
  return resultOfFilter;
}

